import { useCallback, useState, type ReactNode } from "react";
import { PortalContainerProvider } from "@theorgchartdev/storybook";
import { EscapePortalContainerProvider } from "./EscapePortalContainer";

interface AppPortalContainerProps {
  className?: string;
  children: ReactNode;
}

/**
 * Wrapper that provides PortalContainerProvider context.
 * Portaled components (tooltips, popovers, modals) render into this container,
 * inheriting theme classes for proper styling in both standalone and MFE modes.
 * Also hosts the body-level escape layer for overlays that must leave this container.
 */
const AppPortalContainer = ({ className, children }: AppPortalContainerProps) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const containerRef = useCallback((node: HTMLDivElement | null) => {
    setContainer(node);
  }, []);

  return (
    <div className={className} ref={containerRef}>
      <PortalContainerProvider container={container}>
        <EscapePortalContainerProvider className={className}>
          {children}
        </EscapePortalContainerProvider>
      </PortalContainerProvider>
    </div>
  );
};

export default AppPortalContainer;
